import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { retry } from 'rxjs/operators';
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class MoneyService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Money');
	}

	loadAll(): Observable<ePM.Logic.Money[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForCompany(id: System.Guid): Observable<ePM.Logic.Money[]> {
		return this.myBaseService.loadAll(this.url + '/LoadAll/' + id);
	}
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.Money> {
		return this.myBaseService.save(tempItem, this.url);
	}
	get(id: System.Guid): Observable<ePM.Logic.Money> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string): Observable<ePM.Logic.Money[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search');
	}
	runDateReport(searchItem: ePM.Logic.DateSearch): Observable<ePM.Logic.Money[]> {
		return this.myBaseService.post(searchItem, this.url + '/ByDates');
	}
	getReceipt(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(null, this.url + '/Receipt/' + id);
	}
}
